import { KeyStatus } from "../entities/dtos/key-history.dto";
import { TFunction } from "i18next";

export const getStatusText = (statusCode: number, t: TFunction): string => {
  switch (statusCode) {
    case KeyStatus.Inventory:
      return t("keyHistory.status.inventory");
    case KeyStatus.Active:
      return t("keyHistory.status.active");
    case KeyStatus.Blocked:
      return t("keyHistory.status.blocked");
    case KeyStatus.Deleted:
      return t("keyHistory.status.deleted");
    default:
      return t("keyHistory.status.unknown");
  }
};
